// src/pages/ModeratorPanel.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AddClientModal from "../components/AddClientModal";
import AddAreaModal from "../components/AddAreaModal";
import DeleteAreaClientModal from "../components/DeleteAreaClientModal";
import WorkTimeStatisticsModal from "../components/WorkTimeStatisticsModal";
import AssignOrdersModal from "../components/AssignOrdersModal";

import "./AdminPanel.css";
import { API_URL } from "../config";

function ModeratorPanel() {
  const navigate = useNavigate();

  /* ---------------- STANY ---------------- */
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [showAddAreaModal, setShowAddAreaModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [message, setMessage] = useState("");

  // Statystyki (jak u Admina)
  const statsOptions = ["Mój Czas Pracy", "Czas Pracy Pracownika", "Czas Pracy Zlecenia"];
  const [selectedOption, setSelectedOption] = useState("");
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [statsData, setStatsData] = useState(null);
  const [loadingStats, setLoadingStats] = useState(false);
  const [statsError, setStatsError] = useState("");

  // Przydzielanie zleceń
  const [assignableCount, setAssignableCount] = useState(0);
  const [loadingAssignable, setLoadingAssignable] = useState(false);
  const [showAssignOrdersModal, setShowAssignOrdersModal] = useState(false);

  /* ---------------- EFEKTY ---------------- */
  useEffect(() => {
    fetchAssignableCount();
  }, []);

  const fetchAssignableCount = async () => {
    setLoadingAssignable(true);
    try {
      const res = await fetch(`${API_URL}/orders`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd pobierania zleceń");
      const data = await res.json();
      const count = (data || []).filter((o) => {
        const execId = o.osoba_wykonujaca_id == null ? null : Number(o.osoba_wykonujaca_id);
        return execId === null || execId === 29;
      }).length;
      setAssignableCount(count);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingAssignable(false);
    }
  };

  /* ---------------- HANDLERY ---------------- */
  const handleOptionClick = (opt) => {
    setSelectedOption(opt);
    if (opt === "Mój Czas Pracy") fetchMyTimeStats();
    else setStatsData(null);
    setShowStatsModal(true);
  };

  const fetchMyTimeStats = async () => {
    setLoadingStats(true);
    setStatsError("");
    try {
      const res = await fetch(
        `${API_URL}/working_time/statistics/my`,
        { credentials: "include" }
      );
      if (!res.ok) throw new Error("Błąd pobierania statystyk.");
      setStatsData(await res.json());
    } catch (err) {
      setStatsError(err.message);
    } finally {
      setLoadingStats(false);
    }
  };

  /* ================= RENDER ================= */
  return (
    <section className="admin-panel-grid">
      {/* ------------ NAGŁÓWEK ------------ */}
      <h2 className="admin-panel-title">Panel Moderatora</h2>

      {/* ------------ KOLUMNA 1 ------------ */}
      <div className="admin-col">
        <h3>Zarządzanie Zleceniami</h3>
        <button
          className="btn-submit"
          onClick={() => setShowAssignOrdersModal(true)}
          disabled={loadingAssignable}
        >
          Zlecenia Wymagające Przydzielenia ({assignableCount})
        </button>
      </div>

      {/* ------------ KOLUMNA 2 ------------ */}
      <div className="admin-col">
        <h3>Organizacja Pracy i Statystyki</h3>
        <button className="btn-submit" onClick={() => navigate("/kalendarz")}>
          Kalendarz
        </button>
        {statsOptions.map((opt) => (
          <button key={opt} className="btn-submit" onClick={() => handleOptionClick(opt)}>
            {opt}
          </button>
        ))}
      </div>

      {/* ------------ KOLUMNA 3 ------------ */}
      <div className="admin-col">
        <h3>Zarządzanie Systemem</h3>
        <button className="btn-submit" onClick={() => setShowAddClientModal(true)}>
          Dodaj Klienta
        </button>
        <button className="btn-submit" onClick={() => setShowAddAreaModal(true)}>
          Dodaj Obszar
        </button>
        <button className="btn-submit" onClick={() => setShowDeleteModal(true)}>
          Usuń Obszar / Klienta
        </button>
      </div>

      {message && <p className="admin-message">{message}</p>}

      {/* --- Modale: Klienci/Obszary/Usuwanie --- */}
      {showAddClientModal && (
        <AddClientModal
          onClose={() => setShowAddClientModal(false)}
          onSave={() => setShowAddClientModal(false)}
        />
      )}
      {showAddAreaModal && (
        <AddAreaModal
          onClose={() => setShowAddAreaModal(false)}
          onSave={() => setShowAddAreaModal(false)}
        />
      )}
      {showDeleteModal && (
        <DeleteAreaClientModal
          onClose={() => setShowDeleteModal(false)}
          onDeleteSuccess={() => {
            setShowDeleteModal(false);
            setMessage("✅ Pomyślnie usunięto");
          }}
        />
      )}

      {/* --- Modal statystyk --- */}
      {showStatsModal && (
        <WorkTimeStatisticsModal
          onClose={() => setShowStatsModal(false)}
          option={selectedOption}
          statsData={statsData}
          loadingStats={loadingStats}
          statsError={statsError}
        />
      )}

      {/* --- Modal przydzielania --- */}
      {showAssignOrdersModal && (
        <AssignOrdersModal
          visible
          onClose={() => {
            setShowAssignOrdersModal(false);
            fetchAssignableCount(); // odśwież licznik po zmianach
          }}
        />
      )}
    </section>
  );
}

export default ModeratorPanel;
